import {gql} from "@apollo/client";


const common = `
  id
  name
`

export const getLocationsQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getLocations(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getLocations(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}






